<template>
    <div class="terms-wrapper">
        <app-header-mini :img="'/static/img/terms/header.jpg'"></app-header-mini>
        <div class="terms-content">
            <h1 class="indent">Общи условия</h1>

          <p class="indent">Този уеб сайт е собственост на АЛКОМЕТ АД. Отваряйки страницата на АЛКОМЕТ АД, вие приемaте условията за ползване.</p>
          <p class="indent">Имате право да използвате предоставената в уеб сайта информация, само за да улесните Вашите бизнес и търговски взаимоотношения с нас.</p>
          <p class="indent">Нямате право да променяте, копирате, публикувате и/или разпространявате каквато и да била част от съдържанието на уеб сайта без изричното писмено разрешение от страна на АЛКОМЕТ АД, както и по какъвто и да било друг начин да нарушавате авторските права върху публикуваните в този уеб сайт текстови материали, данни, снимков материал и всякаква друга информация.</p>
          <p class="indent">АЛКОМЕТ АД си запазва правото да редактира съдържанието на този уеб сайт и да прекратява достъпа до него по всяко време, без да дължи предварително уведомление на потребителите на уеб сайта. Този уеб сайт и неговото съдържание се публикуват за Ваше удобство. АЛКОМЕТ АД не гарантира, че уеб страниците не съдържат грешки и че достъпът до тях е непрекъсваем. Не носим никаква отговорност за загуба на информация при презареждане на уеб сайта или при копиране на материали, образи, текст и друга информация от него.</p>
          <p class="indent">Публикуваните търговски марки, лого и основни елементи от корпоративната идентичност на АЛКОМЕТ АД са регистрирани като фирмени знаци и защитени съгласно законите на Република България и международните стандарти.</p>
          <p class="indent">Всички материали от този сайт са защитени от Закона за авторското право.</p>
          <p class="indent">Заявките и предложенията до нас, изпращани чрез този сайт, имат само характер на предварителни запитвания с цел информираност. За конкретни заявки и постигане на договорености, молим да се свържете с обявените в сайта лица за контакти.</p>
          <p class="indent">Основните нормативни актове, които АЛКОМЕТ АД съблюдава при ръководенето на бизнеса си, са: Закон за публично предлагане на ценни книжа и неговия правилник за прилагане, Търговски закон, Закон за счетоводството, Закон за авторското право, Закон за независимия финансов одит, Закон за вътрешния одит в публичния сектор, Закон срещу пазарните злоупотреби с финансови инструменти, Национални и международни счетоводни стандарти, както и Международно-признатите принципи за добро корпоративно управление, Кодекса на труда, Националния кодекс за корпоративно управление и др.</p>


        </div>
    </div>
</template>

<script>
import HeaderMini from "./shared/HeaderMini";
export default {
  components: {
    appHeaderMini: HeaderMini
  }
};
</script>

<style scoped>
.terms-content {
  padding: 0 0 60px;
}
.terms-content > h1 {
  font-size: 34px;
  font-weight: 500;
  margin: 0 auto 25px;
  width: 800px;
}
.terms-content > p {
  font-size: 19px;
  text-align: justify;
  line-height: 32px;
  margin: 15px auto;
  width: 800px;
}
@media screen and (max-width: 1000px) {
  .terms-content > h1 {
    font-size: 20px;
    padding: 0 30px;
    width: 100%;
  }
  .terms-content > p {
    font-size: 16px;
    margin: 15px 0;
    padding: 0 30px;
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Terms.vue